import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import GenericForm from '@/components/GenericForm.vue'
import EventoService from '@/services/EventoService'
import { IEvento, IInputEvento as InputType, ITipoDaSessao } from '../../../common/types/Evento'
import { authModule, userModule } from '../../store'
import { obrigatorio, urlValida } from '../../shareds/regras'
import Irmao from '../../../common/types/Irmao'
import { tiposDeSessao, temPermissaoDeSessao, grausDeSessao } from '../../../common/shareds/sharedEvento'
import { displayEntidade } from '../../shareds/sharedsEvento'
import { useQueryClient } from '@tanstack/vue-query'
import { Loja } from 'common/types/Loja'
import { onBeforeRouteLeave, useRoute, useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormEvento',
  props: {
	novo: { type: Boolean, default: false },
	id: { type: String },
},
  setup(__props) {



const queryClient = useQueryClient()
const router = useRouter()
const route = useRoute()

const genericForm = ref<{ data: InputType, validarSaida: () => false | void }>()

const service = EventoService

const mostraDialogoDeLink = ref(false)
const indiceLinkEdicao = ref(-1)
const linkEditado = ref({ texto: '', url: '' })

const lojas = computed(() => {
	if (!userModule.currentUser || userModule.currentUser.role === 'Visitante') return []
	return [
		userModule.currentUser.loja,
		...userModule.currentUser.lojas.map(loja => loja.loja),
	]
})

const opcoes = computed((): ITipoDaSessao[] => {
	if (
		!authModule.role ||
		!userModule.currentUser ||
		userModule.currentUser.role === 'Visitante'
	) return []

	return tiposDeSessao.filter(tipo => temPermissaoDeSessao(tipo, authModule.role)
		&& (tipo.tipoDaEntidade !== 'potencia' || (userModule.currentUser as Irmao).potencia.nome === tipo.nome))
})

function salvarEvento(evento: IEvento) {
	queryClient.invalidateQueries({
		queryKey: ['eventos'],
	})
	router.push({
		name: 'agenda',
		params: { id: evento._id },
	})
}

function criarObjeto(): InputType {
	const tipoDaSessao = opcoes.value[0]
	const evento: InputType = {
		tipoDaSessao,
		data: (route.query.data as string | undefined) || new Date().toISOString().split('T')[0],
		grauDaSessao: null,
		entidade: null,
		presencas: [],
		links: [],
	}
	alterarTipoDaSessao(evento, tipoDaSessao)
	return evento
}

function alterarTipoDaSessao(evento: InputType, tipoDaDessao: ITipoDaSessao) {
	if (!tipoDaDessao) {
		evento.entidade = null
		return
	}
	if (!userModule.currentUser || userModule.currentUser.role === 'Visitante') return

	evento.entidade = obterEntidadeDoUsuario(
		tipoDaDessao.tipoDaEntidade,
		userModule.currentUser,
	)
}

function alterarLojaDoEvento(evento: InputType, loja: Loja) {
	evento.entidade = loja
	evento.horario = evento.horario || loja.horarioDaSessao
}

function obterEntidadeDoUsuario(tipo: 'somar' | 'potencia' | 'loja', usuario: Irmao) {
	switch (tipo) {
		case 'somar':
			return usuario.somar ?? null
		case 'potencia':
			return usuario.potencia ?? null
		case 'loja':
			return usuario.loja ?? null
		default:
			return null
	}
}

function adicionarLink() {
	indiceLinkEdicao.value = -1
	linkEditado.value = { texto: '', url: '' }
	mostraDialogoDeLink.value = true
}

function editarLink(index: number) {
	indiceLinkEdicao.value = index
	linkEditado.value = { ...genericForm.value!.data.links[index] }
	mostraDialogoDeLink.value = true
}

function fecharDialogLink() {
	mostraDialogoDeLink.value = false
}

function salvarLink() {
	if (indiceLinkEdicao.value === -1) {
		genericForm.value!.data.links.push({ ...linkEditado.value })
	} else {
		genericForm.value!.data.links.splice(indiceLinkEdicao.value, 1, linkEditado.value)
	}
	fecharDialogLink()
}

function removerLink(index: number) {
	if (!confirm('Deseja remover este link?')) return
	genericForm.value!.data.links?.splice(index, 1)
}

onBeforeRouteLeave((to, from, next) => {
	next(genericForm.value!.validarSaida())
})

return { __sfc: true,queryClient, router, route, genericForm, service, mostraDialogoDeLink, indiceLinkEdicao, linkEditado, lojas, opcoes, salvarEvento, criarObjeto, alterarTipoDaSessao, alterarLojaDoEvento, obterEntidadeDoUsuario, adicionarLink, editarLink, fecharDialogLink, salvarLink, removerLink, GenericForm, obrigatorio, urlValida, grausDeSessao, displayEntidade }
}

})